//
//
//
//

import a from '../assets/images/111.jpg'
import b from '../assets/images/222.jpg'
import c from '../assets/images/333.jpg'
export default {
  name: 'app',
  data () {
      return {
        imgSize: {
          width: 520,
          height: 280
        },
        swiperSrcs: [
            {src: a},
            {src: b},
            {src: c}
        ]
      }
  },
  methods: {
    click_img: function (index) {
      console.log(index)
    }
  }
}



// WEBPACK FOOTER //
// ./src/example/App.vue